/**
 * Centralized environment detection and configuration
 * Maps hostnames to environment-specific settings
 * Allows single artifact promotion across Dev → QA → QA-DR → UAT → Prod → Prod-DR
 */

import { API_ENDPOINTS, GTM_IDS, DYNATRACE_URLS, SHARED_TELEMETRY, detectEnvironmentFromHostname } from './environmentConstants'

const ENV_CONFIG = {
  production: {
    apiUrl: API_ENDPOINTS.production,
    gtmId: GTM_IDS.production,
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS.production
  },
  'prod-dr': {
    apiUrl: API_ENDPOINTS['prod-dr'],
    gtmId: GTM_IDS['prod-dr'],
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS['prod-dr']
  },
  qa: {
    apiUrl: API_ENDPOINTS.qa,
    gtmId: GTM_IDS.qa,
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS.qa
  },
  'qa-dr': {
    apiUrl: API_ENDPOINTS['qa-dr'],
    gtmId: GTM_IDS['qa-dr'],
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS['qa-dr']
  },
  uat: {
    apiUrl: API_ENDPOINTS.uat,
    gtmId: GTM_IDS.uat,
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS.uat
  },
  dev: {
    apiUrl: API_ENDPOINTS.dev,
    gtmId: GTM_IDS.dev,
    rollbarToken: SHARED_TELEMETRY.rollbarToken,
    dynatraceUrl: DYNATRACE_URLS.dev
  },
  localhost: {
    apiUrl: API_ENDPOINTS.localhost
  }
}

/**
 * Detect environment by hostname
 */
const detectEnvironment = () => {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return 'dev'
  }

  return detectEnvironmentFromHostname(window.location.hostname)
}

/**
 * Get the full config object for the detected environment
 */
export const getEnvironmentConfig = () => {
  const env = detectEnvironment()
  return ENV_CONFIG[env] || ENV_CONFIG.dev
}

/**
 * Get a specific config value for the detected environment
 */
export const getEnvironmentValue = (key) => {
  const config = getEnvironmentConfig()
  return config[key] || null
}
